import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding-right: 2em;
`;

const Emoji = styled.span`
  transform: translateY(-0.1em);

  display: inline-block;
`;

const NdrBannerMessage = () => (
  <Wrapper>
    <span>
      Welcome National Debt Relief members! <Emoji>🙌</Emoji>
    </span>
  </Wrapper>
);

export default NdrBannerMessage;
